(function() {
  console.log('Bundle validation script loaded');
  
  // Wait for page to fully load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  function init() {
    const isBundleProduct = document.querySelector('.bundle-product-notice');
    
    if (!isBundleProduct) {
      console.log('Not a bundle product');
      return;
    }
    
    console.log('Bundle product detected, setting up validation');
    
    // Intercept fetch requests to /cart/add
    const originalFetch = window.fetch;
    window.fetch = function(...args) {
      const url = args[0];
      
      if (typeof url === 'string' && url.includes('/cart/add')) {
        console.log('Cart add intercepted');
        return validateBeforeAdd().then(canAdd => {
          if (canAdd) {
            console.log('Validation passed, proceeding with add');
            return originalFetch.apply(this, args);
          } else {
            console.log('Validation failed, blocking add');
            return Promise.reject(new Error('Bundle validation failed'));
          }
        });
      }
      
      return originalFetch.apply(this, args);
    };
    
    // Also intercept form submissions
    const forms = document.querySelectorAll('form[action*="/cart/add"]');
    forms.forEach(form => {
      form.addEventListener('submit', function(e) {
        console.log('Form submit intercepted');
        e.preventDefault();
        e.stopImmediatePropagation();
        
        validateBeforeAdd().then(canAdd => {
          if (canAdd) {
            // Allow the form to submit
            const formData = new FormData(form);
            fetch('/cart/add.js', {
              method: 'POST',
              body: formData
            })
            .then(response => response.json())
            .then(data => {
              window.location.href = '/cart';
            })
            .catch(error => {
              console.error('Error adding to cart:', error);
            });
          }
        });
      }, true);
    });
    
    // Intercept button clicks
    const addToCartButtons = document.querySelectorAll('button[name="add"], button[type="submit"]');
    addToCartButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        if (button.closest('form[action*="/cart/add"]')) {
          console.log('Add to cart button clicked');
          e.preventDefault();
          e.stopImmediatePropagation();
          
          validateBeforeAdd().then(canAdd => {
            if (!canAdd) {
              // Validation failed, error already shown
              return;
            }
            
            // Get form data
            const form = button.closest('form');
            const formData = new FormData(form);
            
            fetch('/cart/add.js', {
              method: 'POST',
              body: formData
            })
            .then(response => response.json())
            .then(data => {
              window.location.href = '/cart';
            })
            .catch(error => {
              console.error('Error adding to cart:', error);
              showBundleError('Error adding to cart. Please try again.');
            });
          });
        }
      }, true);
    });
  }
  
  function validateBeforeAdd() {
    return fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        console.log('Current cart:', cart);
        
        const otherProductCount = cart.item_count;
        console.log('Other products in cart:', otherProductCount);
        
        if (otherProductCount >= 3) {
          return true;
        } else {
          const needed = 3 - otherProductCount;
          showBundleError(`You need ${needed} more product${needed > 1 ? 's' : ''} in your cart to purchase this bundle item. Please add at least 3 other products first.`);
          return false;
        }
      })
      .catch(error => {
        console.error('Error checking cart:', error);
        showBundleError('Unable to verify cart contents. Please try again.');
        return false;
      });
  }
  
  function showBundleError(message) {
    const existingError = document.querySelector('.bundle-error-message');
    if (existingError) {
      existingError.remove();
    }
    
    const errorDiv = document.createElement('div');
    errorDiv.className = 'bundle-error-message';
    errorDiv.innerHTML = `
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 15H9V13H11V15ZM11 11H9V5H11V11Z" fill="#dc3545"/>
      </svg>
      <p>${message}</p>
    `;
    
    const noticeBox = document.querySelector('.bundle-product-notice');
    if (noticeBox) {
      noticeBox.parentNode.insertBefore(errorDiv, noticeBox.nextSibling);
      
      setTimeout(() => {
        errorDiv.remove();
      }, 5000);
    }
  }
})();
